import { render, staticRenderFns } from "./AddParties.vue?vue&type=template&id=a724d6e2&"
import script from "./AddParties.vue?vue&type=script&lang=js&"
export * from "./AddParties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports